/**
 * 模組頁面代碼 : 1220-UI-01
 * 頁面說明 : 梯控申請清單列表頁面
 * @module modules/elevator-apply/components/ElevatorApplyPage
 */

// ----- import from npm modules -----
import $ from 'jquery';

// ----- import from base libraries -----
import {
    React,
    PropTypes,
    BaseComponent,
    connect,
    AccessModeEnums,
    ModuleEnums,
} from '../../../components/BaseComponent';
import {
    DataTableComponent,
    batchCheckControls,
} from '../../../components/CommonComponent';

import { AlertModalModeEnums } from 'web/components/AlertModal';
import Breadcrumb from '../../../features/main-frame/components/Breadcrumb';

class ElevatorApplyPage extends BaseComponent {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            searchBuildingId: '',
            searchElevatorId: '',
            searchApplicantName: '',
            searchApplicantType: '',
            elevatorList: null,
        };
        this.setSearchBuildingId = this.setSearchBuildingId.bind(this);
        this.setSearchElevatorId = this.setSearchElevatorId.bind(this);
        this.setSearchApplicantName = this.setSearchApplicantName.bind(this);
        this.setSearchApplicantType = this.setSearchApplicantType.bind(this);
        this.setElevatorList = this.setElevatorList.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.prepareApplyTable = this.prepareApplyTable.bind(this);
        this.addEventListeners = this.addEventListeners.bind(this);
        this.onBatchHandle = this.onBatchHandle.bind(this);
    }

    setSearchBuildingId(searchBuildingId) {
        this.setState({ searchBuildingId: searchBuildingId });
    }

    setSearchElevatorId(searchElevatorId) {
        this.setState({ searchElevatorId: searchElevatorId });
    }

    setSearchApplicantName(searchApplicantName) {
        this.setState({ searchApplicantName: searchApplicantName });
    }

    setSearchApplicantType(searchApplicantType) {
        this.setState({ searchApplicantType: searchApplicantType });
    }

    setElevatorList(elevatorList) {
        this.setState({ elevatorList: elevatorList });
    }

    // Handle change event
    handleChange = (event) => {
        const target = event.target;
        let value = target.value;

        // 當選擇大樓時，要更新電梯選項
        if (target.id === 'searchBuildingSelection') {
            const buildingId = parseInt(value);
            this.setSearchBuildingId(buildingId);
            const building = this.props.buildingSelection.find(building => building.buildingId === buildingId);
            const elevatorList = building !== null && building !== undefined ? building.elevators : [];
            this.setState({ elevatorList });
        }
    };

    prepareApplyTable = () => {
        const { applDetailList } = this.props;
        // 定義資料內容
        const dataSet = applDetailList.map((applDetail) => {
            const applicant = applDetail.applicant;
            let houseAddress = '';
            if (applicant.resident) {
                houseAddress = `${applicant.resident.houseNum}-${applicant.resident.floorDisplay}` +
                    (applicant.resident.roomNum ? `-${applicant.resident.roomNum}` : '');
            }
            return [
                applDetail.applyTime,
                applDetail.flgStatus,
                applDetail.permitTime,
                applDetail.buildingName,
                applDetail.elevatorName,
                applicant.applicantName,
                applicant.mobile,
                applicant.applicantType,
                houseAddress,
                applDetail.applyFloorDisplay,
                applDetail.validateTime,
                applDetail.updateTime,
            ];
        });

        // 定義欄位屬性
        const columnConfig = [
            {
                orderable: false,
                order: null,
                title: '<div class="form-check"><input class="form-check-input" type="checkbox" value="" id="check-all" data-show-indeterminate="true"/><label class="form-check-label" for="check-all"></label></div>',
                data: null,
                render: function (data, type, row, meta) {
                    let checkboxId = 'cks-apply-' + meta.row
                    return `
                                <div class="form-check">
                                    <input class="form-check-input item-cks-apply" type="checkbox" value="" id="${checkboxId}" name="cks" />
                                    <label class="form-check-label" for="${checkboxId}"></label>
                                </div>
                            `
                },
                width: '5%',
            },
            { title: '申請時間', className: 'dt-head-center', data: 0, render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'), type: 'datetime' },
            {
                title: '狀態',
                className: 'dt-center',
                data: 1,
                render: function (data, type, row, meta) {
                    // Mapping of codes to labels and class names
                    const statusMapping = {
                        P: { label: '待核可', className: 'badge bg-warning text-dark fw-bold fs-7' },
                        A: { label: '有效', className: 'badge bg-dark-green text-light fw-bold fs-7' },
                        I: { label: '無效', className: 'badge bg-dark-red text-light fw-bold fs-7' },
                        B: { label: '黑名單', className: 'badge bg-black text-light fw-bold fs-7' },
                        E: { label: '過期', className: 'badge bg-dark-gray text-light fw-bold fs-7' },
                    };

                    // Get the corresponding label and class name based on the data
                    const statusInfo = statusMapping[data] || { label: data, className: 'badge bg-light text-dark fw-bold fs-7' };

                    // Return an HTML string with the label and class name, 防止自動換行
                    return `<span class="${statusInfo.className}" style="white-space:nowrap;">${statusInfo.label}</span>`;
                },
                width: '8%',
            },
            { title: '核可時間', className: 'dt-head-center', data: 2, render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'), type: 'datetime' },
            { title: '大樓名稱', className: 'dt-center', data: 3 },
            { title: '電梯編號', className: 'dt-center', data: 4 },
            { title: '申請人', className: 'dt-center', data: 5 },
            { title: '手機號碼', className: 'dt-center', data: 6 },
            {
                title: '身份',
                className: 'dt-center',
                data: 7,
                render: function (data, type, row, meta) {
                    // Mapping of codes to labels and class names
                    const statusMapping = {
                        R: { label: '住戶' },
                        V: { label: '訪客' },
                        E: { label: '職員' },
                        B: { label: '業主' },
                        O: { label: '其他' },
                    }

                    // Get the corresponding label and class name based on the data
                    const statusInfo = statusMapping[data] || { label: data }

                    // Return an HTML string with the label and class name
                    return `<span>${statusInfo.label}</span>`
                },
            },
            { title: '戶號樓層', className: 'dt-center', data: 8 },
            { title: '申請樓層', className: 'dt-center', data: 9, type: 'natural' },
            { title: '有效期限', className: 'dt-head-center', data: 10, render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'), type: 'datetime' },
            { title: '修改時間', className: 'dt-head-center', data: 11, render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'), type: 'datetime' },
            {
                orderable: false,
                order: null,
                title: '啟用',
                data: 1,
                className: 'dt-center',
                render: (data, type, row, meta) => {
                    let enableId = 'eab-apply-' + meta.row;
                    let isChecked = data === 'A' ? 'checked' : '';
                    let enableButton = this.checkPermission(ModuleEnums.ELEVATOR_APPLY, AccessModeEnums.DELETE) && data !== 'B' && data !== 'E' ? '' : 'disabled';
                    return `<div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="${enableId}" ${isChecked} ${enableButton} />
                                <label class="form-check-label" for="${enableId}"></label>
                            </div>`;
                },
            },
            {
                orderable: false,
                order: null,
                data: 1,
                className: 'dt-right',
                render: (data, type, row, meta) => {
                    let approveId = 'approve-apply-' + meta.row;
                    let resetPasswordId = 'reset-password-' + meta.row;
                    let resetVenderId = 'reset-vender-' + meta.row;
                    let editId = 'edit-apply-' + meta.row;
                    let isDisabled = data === 'P' ? '' : 'disabled';
                    let checkIcon = data === 'P' ? '#ico-check' : '#ico-check-grey';
                    let isEditabled = data === 'E' ? 'disabled' : '';
                    let editIcon = data === 'E' ? '#ico-edit-grey' : '#ico-edit';
                    let approveButton = this.checkPermission(ModuleEnums.ELEVATOR_APPLY, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${approveId}" ${isDisabled} >
                            <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                                <use href="${checkIcon}"></use>
                            </svg>
                            核可
                        </button>` : '';
                    let resetPasswordButton = this.checkPermission(ModuleEnums.ELEVATOR_APPLY, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${resetPasswordId}" ${isEditabled}>
                            重設密碼
                        </button>` : '';
                    let resetVenderButton = this.checkPermission(ModuleEnums.ELEVATOR_APPLY, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${resetVenderId}" ${isEditabled}>
                            重設手機驗證碼
                        </button>` : '';
                    let editButton = this.checkPermission(ModuleEnums.ELEVATOR_APPLY, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${editId}" ${isEditabled}>
                            <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                                <use href="${editIcon}"></use>
                            </svg>
                            修改
                        </button>` : '';
                    return `
                        <div class="btn-group" role="group" aria-label="">
                            ${approveButton}
                            ${resetPasswordButton}
                            ${resetVenderButton}
                            ${editButton}
                        </div>`;
                },
            },
        ];

        // 定義排序設定
        const orderConfig = {
            idx: 1,
            dir: 'dsc',
        };

        // 定義固定欄位設定
        const fixedColumnsConfig = {
            start: 1,
        };

        // 先清除datatable
        if ($.fn.DataTable.isDataTable('#datatable__elevatorApplyList')) {
            $('#datatable__elevatorApplyList').DataTable().destroy();
        }

        // 重新繪製datatable
        DataTableComponent('#datatable__elevatorApplyList', dataSet, columnConfig, orderConfig, fixedColumnsConfig, true, true);
        this.addEventListeners();
        batchCheckControls();
    }

    onNewApplication() {
        // 讀取目前梯控申請查詢條件
        const searchForm = new FormData(document.querySelector('.datatable__search form'));
        const buildingId = parseInt(searchForm.get('searchBuildingSelection') ? searchForm.get('searchBuildingSelection') : 0);
        const elevatorId = parseInt(searchForm.get('searchElevatorSelection') ? searchForm.get('searchElevatorSelection') : 0);
        const applicantName = searchForm.get('searchApplicantName') ? searchForm.get('searchApplicantName') : '';
        const applicantType = searchForm.get('searchApplicantType') && searchForm.get('searchApplicantType') !== 'all' ? searchForm.get('searchApplicantType') : '';
        this.props.fetchApplyList(buildingId, elevatorId, applicantName, applicantType).then(() => {
            // Get data and redraw datatable
            this.prepareApplyTable();
        });
    }

    componentDidMount() {
        // 檢查權限
        this.checkPermission(ModuleEnums.ELEVATOR_APPLY, AccessModeEnums.READ);
    }

    componentDidUpdate(prevProps) {
        const { needElevatorApplyLoad, setNeedElevatorApplyLoad, applDetailList, newApplication, setNewApplication } = this.props;
        if (needElevatorApplyLoad &&
            needElevatorApplyLoad !== prevProps.needElevatorApplyLoad) {
            if (applDetailList.length > 0) {
                this.prepareApplyTable();
            }
            setNeedElevatorApplyLoad(false);
        }

        if (newApplication && newApplication !== prevProps.newApplication) {
            this.onNewApplication();
            setNewApplication(false);
        }
    }

    handleSearch(e) {
        e.preventDefault();
        const searchForm = new FormData(e.target);
        const buildingId = parseInt(searchForm.get('searchBuildingSelection') ? searchForm.get('searchBuildingSelection') : 0);
        const elevatorId = parseInt(searchForm.get('searchElevatorSelection') ? searchForm.get('searchElevatorSelection') : 0);
        const applicantName = searchForm.get('searchApplicantName') ? searchForm.get('searchApplicantName') : '';
        const applicantType = searchForm.get('searchApplicantType') && searchForm.get('searchApplicantType') !== 'all' ? searchForm.get('searchApplicantType') : '';
        this.props.setSearchElevatorApply(buildingId, elevatorId, applicantName, applicantType);
        this.props.fetchApplyList(buildingId, elevatorId, applicantName, applicantType).then(() => {
            // Get data and redraw datatable
            this.prepareApplyTable();
        });
    }

    addEventListeners() {
        if (this.tableRef.current) {
            this.tableRef.current.addEventListener('click', (event) => {
                const button = event.target.closest('.btn');
                const index = button && parseInt(button.id.split('-')[2]);
                const updateApply = this.props.applDetailList[index];
                if (button && button.id.startsWith('approve-apply-')) {
                    const message = `核可 [ ${updateApply.applicant.applicantName}) ] 的申請`;
                    this.props.onEditApplyStatus(AlertModalModeEnums.APPROVE, message, updateApply.applDetailId);
                }
                if (button && button.id.startsWith('reset-password-')) {
                    const message = `重設 [ ${updateApply.applicant.applicantName} ] 的密碼`;
                    const memo = '重新設定為預設密碼(與帳號相同)，請於系統重設密碼後提醒使用者在手機APP中修改新密碼。';
                    this.props.onResetPassword(AlertModalModeEnums.RESETPASSWORD, message, memo, updateApply.applicant.applicantId);
                }
                if (button && button.id.startsWith('reset-vender-')) {
                    const message = `重設 [ ${updateApply.applicant.applicantName} ] 的手機驗證碼`;
                    const memo = '重新設定手機驗證，請於系統重設後提醒使用者重新於手機APP登入後才能完成手機驗證作業。';
                    this.props.onResetVenderId(AlertModalModeEnums.RESETVENDERID, message, memo, updateApply.applicant.applicantId);
                }
                if (button && button.id.startsWith('edit-apply-')) {
                    this.props.onEditApply(index);
                }
            });
        }
        this.tableRef.current.addEventListener('change', (event) => {
            const checkbox = event.target.closest('input[type="checkbox"]');
            if (checkbox && checkbox.id.startsWith('eab-apply-')) {
                const index = parseInt(checkbox.id.split('-')[2]);
                const mode = checkbox.checked ? AlertModalModeEnums.ENABLE : AlertModalModeEnums.DISABLE;
                const updateApply = this.props.applDetailList[index];
                if (updateApply) {
                    let message = '';
                    if (mode === AlertModalModeEnums.ENABLE) {
                        message = `啟用 [ ${updateApply.applicant.applicantName}(樓層 : ${updateApply.applyFloorDisplay}) ] 的資料`;
                    } else {
                        message = `停用 [ ${updateApply.applicant.applicantName}(樓層 : ${updateApply.applyFloorDisplay}) ] 的資料`;
                    }
                    this.props.onEditApplyStatus(mode, message, updateApply.applDetailId);
                } else {
                    console.log('No apply detail found at index:', index);
                }
            }
        });
    }

    onBatchHandle(mode = AlertModalModeEnums.DELETE) {
        const applDetailIds = [];
        const checkboxes = document.querySelectorAll('.item-cks-apply');
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                const applDetailId = this.props.applDetailList[parseInt(checkbox.id.split('-')[2])].applDetailId;
                applDetailIds.push(applDetailId);
            }
        });
        // 如果沒有選擇任何資料就不處理
        if (applDetailIds.length === 0) {
            return;
        }

        this.props.onBatchHandle(mode, applDetailIds);
    }

    render() {
        const { buildingSelection, onNewApply, onImportData, onDefaultPeriod } = this.props;
        return (
            <section id="datatable-container">
                <Breadcrumb categoryName="梯控管理" pageName="梯控申請" />
                <h4>梯控申請</h4>
                <div className="datatable__search">
                    <form className="d-flex gap-2 align-items-end needs-validation" onSubmit={this.handleSearch}>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchBuildingSelection" className="form-label">大樓名稱*</label>
                            <select
                                className="form-select form-select-sm"
                                id="searchBuildingSelection"
                                name="searchBuildingSelection"
                                value={this.state.searchBuildingId}
                                onChange={this.handleChange}
                                required>
                                <option disabled value="">請選擇</option>
                                <option value="0">全部</option>
                                {buildingSelection.map((building, index) => (
                                    <option key={index} value={building.buildingId}>{building.buildingName}</option>
                                ))}
                            </select>
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchElevatorSelection" className="form-label">電梯編號</label>
                            <select
                                className="form-select form-select-sm"
                                id="searchElevatorSelection"
                                name="searchElevatorSelection"
                                value={this.state.searchElevatorId}
                                onChange={e => this.setSearchElevatorId(e.target.value)}
                            >
                                <option disabled value="">請選擇</option>
                                <option value="0">全部</option>
                                {this.state.elevatorList && this.state.elevatorList.map((elevator, index) => (
                                    <option key={index} value={elevator.elevatorId}>{elevator.elevatorName}</option>
                                ))}
                            </select>
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchApplicantName" className="form-label">申請人</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="searchApplicantName"
                                name="searchApplicantName"
                                value={this.state.searchApplicantName}
                                onChange={e => this.setSearchApplicantName(e.target.value)}
                            />
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchApplicantType" className="form-label">身份</label>
                            <select
                                className="form-select form-select-sm"
                                id="searchApplicantType"
                                name="searchApplicantType"
                                value={this.state.searchApplicantType}
                                onChange={e => this.setSearchApplicantType(e.target.value)}
                            >
                                <option disabled value="">請選擇</option>
                                <option value="all">全部</option>
                                <option key="1" value="R">住戶</option>
                                <option key="2" value="V">訪客</option>
                                <option key="3" value="E">職員</option>
                                <option key="4" value="B">業主</option>
                                <option key="5" value="O">其他</option>
                            </select>
                        </div>
                        <div>
                            <button className="btn btn-primary" type="submit" aria-label="搜尋">
                                <svg className="btn__icon" aria-hidden="true">
                                    <use href="#ico-search"></use>
                                </svg>
                            </button>
                        </div>
                    </form>
                </div>
                <div className="datatable__tool">
                    <div className="d-flex align-items-center gap-2">
                        <div className="datatable__tool__label">
                            多筆選擇
                            <div id="checked-count-display"></div>
                        </div>
                        <div className="btn-group btn-group-sm" role="group" aria-label="">
                            {this.checkPermission(ModuleEnums.ELEVATOR_APPLY, AccessModeEnums.UPDATE) && (
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="核可" id="btnBatchApprove" onClick={() => this.onBatchHandle(AlertModalModeEnums.APPROVE)}>
                                    <svg className="btn__icon me-2" aria-hidden="true">
                                        <use href="#ico-check"></use>
                                    </svg>
                                    核可
                                </button>
                            )}
                            {this.checkPermission(ModuleEnums.ELEVATOR_APPLY, AccessModeEnums.DELETE) && (
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="啟用" id="btnBatchEnable" onClick={() => this.onBatchHandle(AlertModalModeEnums.ENABLE)}>啟用</button>
                            )}
                            {this.checkPermission(ModuleEnums.ELEVATOR_APPLY, AccessModeEnums.DELETE) && (
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="停用" id="btnBatchDisable" onClick={() => this.onBatchHandle(AlertModalModeEnums.DISABLE)}>停用</button>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        {this.checkPermission(ModuleEnums.ELEVATOR_APPLY, AccessModeEnums.UPDATE) && (
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                aria-label="設定預設有效天數"
                                id="modalDefaultPeriodBtn"
                                onClick={onDefaultPeriod}
                                data-bs-toggle="modal"
                                data-bs-target="#modalDefaultPeriod"
                            >
                                <svg className="btn__icon me-2" aria-hidden="true">
                                    <use href="#ico-hourglass"></use>
                                </svg>
                                設定預設有效天數
                            </button>
                        )}
                        {this.checkPermission(ModuleEnums.ELEVATOR_APPLY, AccessModeEnums.CREATE) && (
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                aria-label="匯入"
                                id="modalImportBtn"
                                onClick={onImportData}
                                data-bs-toggle="modal"
                                data-bs-target="#modalImport"
                            >
                                <svg className="btn__icon me-2" aria-hidden="true">
                                    <use href="#ico-download"></use>
                                </svg>
                                匯入
                            </button>
                        )}
                        {this.checkPermission(ModuleEnums.ELEVATOR_APPLY, AccessModeEnums.CREATE) && (
                            <button type="button" className="btn btn-sm btn-primary" aria-label="新增" id="modalApplyBtnNew" onClick={onNewApply}>
                                <svg className="btn__icon me-2" aria-hidden="true">
                                    <use href="#ico-plus"></use>
                                </svg>
                                新增
                            </button>
                        )}
                    </div>
                </div>
                <div className="datatable__data" ref={this.tableRef}>
                    <table id="datatable__elevatorApplyList" className="display table table-hover align-middle nowrap"></table>
                </div>
            </section>
        );
    }
}

ElevatorApplyPage.propTypes = {
};

ElevatorApplyPage.defaultProps = {
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ElevatorApplyPage);